module.exports = __webpack_public_path__ + "static/img/a044.8bd7a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a044.jpg
// module id = jZlL
// module chunks = 0